<template>
  <div>
    <div class="head">
      <div class="headbar">
        <div class="container">
          <div class="head-lt">
            <a>欢迎回来到沃德珠宝！</a>
          </div>
          <div class="head-md webCSS">
            <marquee direction="left">
              温馨提示：ECO肉眼干净，EC1 90%肉眼干净，EC2肉眼不干净
              1、未到货品的“地点”一栏显示为”ind”，已到货品显示”HK”，预计3-7个工作日到香港，并不提供具体预计到货时间查询。
              2、实际到货后， 货品“地点”将变更为”HK”。
              3、下单即视为可以接受货品7个工作日之内到港。
              4、货品质量与香港现货库存一致。
            </marquee>
          </div>
        </div>
      </div>
      <div class="head-nav">
        <div class="header">
          <div class="header-lt">
            <div class="logo">
              <a href>
                <img src="/static/img/img/logo.png" />
              </a>
            </div>
          </div>
          <div class="header-ce">
                    <div class="nav">
                        <ul>
                            <li @click="goPage('Home')">首页</li>
                            <li @click="goPage('DiamondSearch')">GIA裸钻</li>
                            <li @click="goPage('MyCar')">我的购物车</li>
                            <li @click="goPage('MyOrder')">我的订单</li>
                            <li @click="goPage('Calculator', true)">计算器</li>
                            <li @click="goPage('FeedBack', true)">问题反馈</li>
                            <li @click="goPage('ChangePass')">修改密码</li>
                            <li @click="loginOut">注销登录</li>
                        </ul>
                    </div>
                </div>
        </div>
      </div>
    </div>
   <div class="war">
        <img src="/static/img/img/banner.png" class="login-img" />
        <div class="container">
            <div class="regme_gird">
                <div id="formregme">
                    <fieldset  class="webCSS">World</fieldset>
                    <fieldset>
                        <i>用户名</i>
                        <input type="text" class="col-default" ref="input1" @click.stop v-model="database.username" placeholder="只允许字母加数字组合">
                    </fieldset>
                    <fieldset>
                        <i>密码</i>
                         <input type="password" class="col-default" ref="input3" @click.stop v-model="database.password" placeholder="请输入密码">
                    </fieldset>
                    <fieldset>
                        <i>确认密码</i>
                        <input type="password" class="col-default" ref="input4" @click.stop v-model="database.confirm_password" placeholder="确认密码">
                    </fieldset>
                    <fieldset>
                        <i>真实姓名</i>
                        <input type="text" class="col-default" ref="input2" @click.stop v-model="database.realname" placeholder="您的真实姓名">
                    </fieldset>
                    <fieldset>
                        <i>手机号</i>
                        <input type="text" class="col-default" ref="input5" @click.stop v-model="database.mobile" placeholder="您的手机号码">
                    </fieldset>
                    <fieldset>
                        <i>验证码</i>
                         <input type="text" class="col-default" ref="input6" @click.stop v-model="database.code" placeholder="您收到的短信验校码">
                    </fieldset>
                    <div class="app-screen-container">
                        <div class="step-button active" v-if="isCodeLength" @click="onSubmit">提交</div>
                        <div class="step-button" v-else-if="options.timing > 0">{{options.timing}}S</div>
                        <div class="step-button active" v-else-if="!isCodeLength" @click="onSendMobileCode">获取验校码</div>
                    </div>
                    <div class="step-notes" v-if="options.existSendMobileCode">
                        请留意您的手机短信息<br>
                        <div v-if="options.timing > 0">如果您长时间没有收到信息, {{options.timing}}s 后可以尝试重新发送</div>
                        <div v-else>如果您长时间没有收到信息, 可以尝试 <span class="text-primary" @click="onSendMobileCode">重新发送</span></div>
                    </div>
                    <!-- <div class="step-notes step-default-notes align-left">
                        登录名格式: {{Configure.FOUNDER_USERNAME}}@XXX，(不可重复)注册成功后不可修改！<br>
                        工号由系统自动生成，不支持指定工号或变更！<br><br>
                        目前暂不支持更改成员密码<br>
                        1、如需更改密码，请登录PC客户端进行操作；<br>
                        2、找回密码，请联系端口管理员重置您的登录密码；<br>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
    <div class="board" style="display: none">
      <div class="board_title">
        <i class="fa fa-file-audio-o" aria-hidden="true"></i>公告栏
        <span>Notice Board</span>
        <a class="board_close"></a>
      </div>
      <p>
        温馨提示：ECO肉眼干净，EC1 90%肉眼干净，EC2肉眼不干净
        1、未到货品的“地点”一栏显示为”ind”，已到货品显示”HK”，预计3-7个工作日到香港，并不提供具体预计到货时间查询。
        2、实际到货后， 货品“地点”将变更为”HK”。
        3、下单即视为可以接受货品7个工作日之内到港。
        4、货品质量与香港现货库存一致。
      </p>
    </div>
  </div>
</template>
<script>
    import ScrollPullDown from '@/public/ScrollPullDown'
    // import _ from 'lodash'
    import Core from '@/until/core'
    export default {
        name: 'StaffRegister',
        data () {
            return {
                options: {
                    step: 1,
                    beBack: true,
                    mobileExist: false,
                    existSendMobileCode: false,
                    timing: 0,
                    accessToken: null
                },
                database: {
                    port: null,
                    fans: null,
                    group: null,
                    customer: null,
                    username: '',
                    realname: '',
                    password: '',
                    confirm_password: '',
                    mobile: '',
                    code: ''
                }
            }
        },
        components: {
            ScrollPullDown
        },
        watch: {},
        computed: {
            Configure () {
                return Core.getOptions()
            },
            BeBackStateEcho () {
                return this.options.step > 1 && this.options.beBack ? '上一步' : true
            },
            isRightUsername () {
                return true
                // const username = String(this.database.username || '')
                // return username.indexOf('@') !== -1 && username.length >= 4
            },
            isCodeLength () {
                return String(this.database.code || '').length >= 5
            },
            isPasswordLength () {
                return String(this.database.password || '').length >= 6
            }
        },
        filters: {},
        methods: {
            goPage (name, bool) {
                const that = this
                if (bool) {
                    return Core.goNext(name, that.$route.params)
                }
                Core.loginExist().then(res => {
                    if (res) {
                        return Core.goNext(name, that.$route.params)
                    }
                    Core.goNext('StaffLogin', that.$route.params)
                })
            },
            loginOut () {
                Core.onRemoveToken()
                Core.goNext('StaffLogin', this.$route.params, true)
            },
            onGetInto (name, extend) {
                return this.$router.push({
                    name: name,
                    params: this.$store.state.routerParams,
                    query: extend || {}
                })
            },
            onSetStep (index) {
                this.options.step = parseInt(index, 10) || 1
            },
            onSubmit () {
                const that = this
                if (that._sub) {
                    return
                }
                const data = {}
                const param = {
                    username: that.database.username || '',
                    realname: that.database.realname,
                    password: (that.database.password || '').replace(/(^\s*)|(\s*$)/g, ''),
                    confirm_password: that.database.confirm_password,
                    mobile: that.database.mobile,
                    code: that.database.code
                }
                if (!/^\d{4,8}$/.test(param.code)) {
                    return that.$store.commit('onChangeAppMessage', '请输入正确的验证码')
                } else if (!/^[a-zA-Z0-9]{2,}$/.test(param.username)) {
                    return that.$store.commit('onChangeAppMessage', '登录名不合规格, 请重试')
                } else if (!/^.{2,20}$/.test(param.realname)) {
                    return that.$store.commit('onChangeAppMessage', '请填写您的姓名')
                } else if (!param.password || param.password !== param.confirm_password) {
                    return that.$store.commit('onChangeAppMessage', '两次的密码不一致, 请重试')
                } else if (!/^[a-z0-9_-]{6,32}$/.test(param.confirm_password)) {
                    return that.$store.commit('onChangeAppMessage', '密码长度必须在 6-32 个字符')
                } else if (!/^\d{10,11}$/.test(param.mobile)) {
                    return that.$store.commit('onChangeAppMessage', '请填入正确的手机号')
                }
                data.database = param
                data.uid = that.$route.params.Uid
                that._sub = true
                that.$store.commit('onChangeAppLoaderShow', '正在提交, 请稍候...')
                Core('Api/Staff/RegisterDiamond', data).then(body => {
                    that._sub = false
                    that.$store.commit('onChangeAppLoaderShow', false)
                    if (!body.data || body.data.error_code) {
                        return that.$store.commit('onChangeAppMessage', body.data.error_msg || '登记失败, 请稍候再试')
                    }
                    layer.msg('注册成功', {icon: 1})
                    setTimeout(() => {
                        that.goBack()
                    }, 1000)
                })
            },
            onSendMobileCode () {
                const that = this
                const data = {}
                const param = {
                    username: that.database.username || '',
                    realname: that.database.realname,
                    password: (that.database.password || '').replace(/(^\s*)|(\s*$)/g, ''),
                    confirm_password: that.database.confirm_password,
                    mobile: that.database.mobile,
                    code: that.database.code
                }
                if (that.isCodeLength) {
                    return null
                } else if (that.options.timing > 0) {
                    return that.$store.commit('onChangeAppMessage', '请稍候再试')
                } else if (!/^[a-zA-Z0-9]{2,}$/.test(param.username)) {
                    return that.$store.commit('onChangeAppMessage', '登录名必须大于2个字符长度')
                } else if (!/^.{2,20}$/.test(param.realname)) {
                    return that.$store.commit('onChangeAppMessage', '请填写您的姓名')
                } else if (!param.password || param.password !== param.confirm_password) {
                    return that.$store.commit('onChangeAppMessage', '两次输入的密码不一致')
                } else if (!/^[a-z0-9_-]{6,32}$/.test(param.confirm_password)) {
                    return that.$store.commit('onChangeAppMessage', '密码长度必须在 6-32 个字符')
                } else if (!/^\d{10,11}$/.test(param.mobile)) {
                    return that.$store.commit('onChangeAppMessage', '请填入正确的手机号')
                }
                data.database = param
                data.uid = that.$route.params.Uid
                that.$store.commit('onChangeAppLoaderShow', true)
                Core('Api/Staff/SendRegisterValidates', data).then(body => {
                    that.$store.commit('onChangeAppLoaderShow', false)
                    if (!body.data.error_code && parseInt(body.data.data, 10) === parseInt(param.mobile, 10)) {
                        that.options.existSendMobileCode = true
                        that.options.timing = 60
                        let timingIndex = null
                        const timingCall = () => {
                            if (that.options.timing <= 0) {
                                timingIndex && clearTimeout(timingIndex)
                                return null
                            }
                            that.options.timing -= 1
                            setTimeout(timingCall, 1000)
                        }
                        return timingCall()
                    }
                    that.$store.commit('onChangeAppMessage', body.data.error_msg)
                })
            },
            onClose () {
                if (wx) {
                    wx.closeWindow()
                }
            },
            onInputBlur () {
                let keys = Object.keys(this.$refs)
                let index = keys.length - 1
                for (; index >= 0; index -= 1) {
                    const name = keys[index]
                    this.$refs[name].blur()
                }
            },
            goBack () {
                Core.goBack()
            }
        },
        mounted () {}
    }
</script>
<style scoped>
@import "../../node_modules/swiper/dist/css/swiper.min.css";
@import "../../static/css/yellow.css";
@import "../../static/css/font-awesome.css";
.nav{ height: 90px; }
.header-ce{ width:1000px; }
.header-ce ul li{ float: left; line-height: 90px; width:100px; text-align: center;}
.Home-banner {
  width: 100%;
  height: 600px;
  overflow: hidden;
  background-color: #fff;
}
.btn-hk {
  color: #fff;
  padding: 8px 16px;
  line-height: 100px;
  background: #f268a3;
  border-radius: 2px;
  font-size: 13px;
}

.modelBox {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.65);
  overflow: hidden;
  z-index: 999;
}

.model {
  position: absolute;
  width: 1000px;
  height: 500px;
  margin: 0 auto;
  left: 0;
  right: 0;
  top: calc(50% - 350px);
  z-index: 9999;
  text-align: center;
  padding: 50px 0;
}

.closed {
  display: block;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  position: absolute;
  right: 150px;
  top: 120px;
  text-align: center;
  line-height: 22px;
  background: #e0b12f;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}

.timeer {
  text-align: center;
  position: absolute;
  bottom: 0;
  width: 100px;
  margin: auto;
  left: 0;
  right: 0;
  line-height: 40px;
  font-size: 14px;
  color: #ffeb3b;
  font-size: 30px;
  border-radius: 5px;
}

.app-screen { position: relative; width: 100%; height: 100%; perspective: 1200px; transform-style: preserve-3d; background-color: #FFF; }
.app-screen-main { transform: translate3d(0, 0, 0); }
.app-screen-container{ padding-top: 5px; padding-right: 10px; padding-left: 10px; position: relative; }
.app-screen-container .step-enroll{ position: relative; font-size: 16px; border-bottom: 1px solid #EBEBEB; padding-bottom: 15px; padding-top: 12px; }
.app-screen-container .step-enroll .identifier{ position: absolute; top: 12px; left: 0; width: 50px; height: 25px; line-height: 25px; color: #CCC; text-align: center; }
.app-screen-container .step-enroll .username-whole{ color: #999; padding-left: 10px; }
.app-screen-container .step-enroll .username{ padding-right: 10px; padding-left: 3px;}
.app-screen-container .step-enroll .col-default{ padding-right: 10px; padding-left: 10px;}
.app-screen-container .step-enroll input{ border: 0; background-color: transparent; width: 100%; height: 25px; line-height: 25px; padding-left: 50px; outline: none; }
.app-screen-container .step-notes{ font-size: 12px; text-align: right; color: #B5B6CA; padding-top: 18px; padding-bottom: 18px; font-size: 14px; }
.app-screen-container .step-notes.align-left{ text-align: left; }
.app-screen-container .step-default-notes{ font-size: 12px; color: #999; }
.app-screen-container .step-tools{ margin-top: 20px; text-align: center; height: 22px; line-height: 22px; }
.app-screen-container .step-container{ padding-top: 30px; text-align: center; font-size: 16px; }
.app-screen-container .step-button{ display: block; width: 100%; height: 50px; line-height: 50px; text-align: center; background-color: #CCCCCC; color: #FFF; border-radius: 25px; border: 1px solid transparent; }
.app-screen-container .step-button.active{ border-color: #ff410f; background: #ff410f; }
.app-screen-container .step-button.ignore{ margin-bottom: 8px; background-color: transparent; color: #FF6068; }

.app-screen-container .success-container{ padding-top: 50px; padding-right: 30px; padding-left: 30px; text-align: center; }
.app-screen-container .success-message{ line-height: 35px; padding-top: 20px; }

</style>



// WEBPACK FOOTER //
// src/components/StaffRegister.vue